<template>
    <div class="NodeEditor SupporterNodeEditor">
        <NodeSaveStatus></NodeSaveStatus>
        <NodeHeaderEditor
            key="NodeHeaderEditor"
            :name.sync="node.name"
            :id="node.id"
            :slug="node.slug"
            :type="node.type"
            ref="NodeHeaderEditor"
            @save="saveNode"
            @delete="deleteNode"
            @close="closePanelRight"
        ></NodeHeaderEditor>
        <div class="scroll-container fci-scrollbar">
            <ScenarioCard name="Variable">
                <div v-for="(variable, i) in variableList" :key="i" class="variable-container">
                    <v-layout class="variable-header">
                        <div class="variable-title">{{ variable.name }}</div>
                        <v-spacer></v-spacer>
                        <img src="/img/scenario/delete_2.svg" alt="delete" @click="removeVariable(i)">
                    </v-layout>
                    <div class="variable-body">
                        <table class="variable-table">
                            <tr>
                                <td>Name</td>
                                <td>
                                    <ScenarioInput v-model="variable.name" style="width: 100%"></ScenarioInput>
                                </td>
                            </tr>
                            <tr>
                                <td>Prompt</td>
                                <td>
                                    <ScenarioInput v-model="variable.prompt" style="width: 100%"
                                                   class="my-1"></ScenarioInput>
                                </td>
                            </tr>
                            <tr>
                                <td>Reprompt</td>
                                <td>
                                    <ScenarioInput v-model="variable.rePrompt" style="width: 100%"></ScenarioInput>
                                </td>
                            </tr>
                        </table>
                    </div>

                </div>
                <v-layout>
                    <v-spacer></v-spacer>
                    <v-btn class="mx-0" @click="addVariable">add Variable</v-btn>
                </v-layout>
            </ScenarioCard>
            <ScenarioCard name="Special out condition">
                <ConditionEditor :items="node.config.specialOutCondition" @save="saveNode"></ConditionEditor>
            </ScenarioCard>
        </div>
        <NodeFooterEditor
            @menuSelect="onMenuSelect($event)"
        ></NodeFooterEditor>
    </div>
</template>

<script>
import NodeEditor from "@/views/Scenario/NodeEditor/NodeEditor";
import NodeFooterEditor from "@/views/Scenario/NodeEditor/common/NodeFooterEditor";
import ScenarioCard from "@/views/Scenario/components/ScenarioCard";
import NodeHeaderEditor from "@/views/Scenario/NodeEditor/common/NodeHeaderEditor";
import NodeSaveStatus from "@/views/Scenario/NodeEditor/NodeSaveStatus";
import ScenarioInput from "@/views/Scenario/components/ScenarioInput";
import ConditionEditor from "@/views/Scenario/NodeEditor/common/ConditionEditor";

export default {
    name: "FormNodeEditor",
    extends: NodeEditor,
    components: {
        ConditionEditor,
        ScenarioInput,
        NodeFooterEditor,
        ScenarioCard,
        NodeHeaderEditor,
        NodeSaveStatus
    },
    data() {
        return {
            variableList: [
                {
                    name: 'name',
                    prompt: 'tên bạn là gì',
                    rePrompt: 'cho mình hỏi lại tên bạn là gì'
                },
                {
                    name: 'name',
                    prompt: 'tên bạn là gì',
                    rePrompt: 'cho mình hỏi lại tên bạn là gì'
                },
                {
                    name: 'name',
                    prompt: 'tên bạn là gì',
                    rePrompt: 'cho mình hỏi lại tên bạn là gì'
                }
            ]
        }
    },
    methods: {
        addVariable() {
            this.variableList.push({
                name: '',
                prompt: '',
                rePrompt: ''
            })
        },
        removeVariable(index) {
            this.variableList.splice(index, 1)
        }
    },
    watch: {
        node() {
            this.variableList = this.node.variableList ? this.$utils.cloneObject(this.node.variableList) : this.variableList
        }
    }
}
</script>

<style scoped lang="scss">
@import "src/views/Scenario/NodeEditor/NodeEditor";

.variable-container {
    padding: 10px 0;
}

.variable-title {
    background: #B2B4C6;
    color: #fff;
    padding: 5px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
}

.variable-body {
    padding: 10px;
    border: 1px solid #EDEDF2;
    border-radius: 5px;
}

.variable-table {
    width: 100%;


    tr td:first-child {
        padding-right: 10px;
        width: 75px;
    }
}
</style>
